import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";

export const snackbarStyle = recipe({
  base: {
    maxWidth: rem(500),
    width: "100%",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    pointerEvents: "auto",
    background: "var(--background)",
    selectors: {
      "&:empty": {
        display: "none",
      },
    },
  },
  variants: {
    paused: {
      true: {
        userSelect: "none",
        overflow: "hidden",
      },
    },
    size: {
      default: {
        borderRadius: theme.borderRadiuses.s,
        padding: theme.spacings.m,
        gap: theme.spacings.s,
      },
    },
    variant: {
      default: {
        color: theme.colors.onPrimary,
        vars: {
          "--background": theme.colors.primary,
        },
      },
      success: {
        color: theme.colors.onSuccess,
        vars: {
          "--background": theme.colors.success,
        },
      },
      warning: {
        color: theme.colors.onWarning,
        vars: {
          "--background": theme.colors.warning,
        },
      },
      error: {
        color: theme.colors.onError,
        vars: {
          "--background": theme.colors.error,
        },
      },
      info: {
        color: theme.colors.onInfo,
        vars: {
          "--background": theme.colors.info,
        },
      },
      accent: {
        color: theme.colors.onPrimary,
        vars: {
          "--background": theme.colors.primary,
        },
      },
    },
  },
  defaultVariants: {
    size: "default",
    variant: "default",
  },
});

export const snackbarContentStyle = recipe({
  base: {
    display: "flex",
    gap: theme.spacings.xs,
    flexDirection: "column",
    // paddingRight: theme.spacings.l,
    alignContent: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
});

export const closeStyle = style({
  position: "absolute",
  top: theme.spacings.s,
  right: theme.spacings.s,
  zIndex: 2,
});

export const overlayStyle = style({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: theme.colors.onBackground,
  transition: transition("opacity"),
});

export const iconStyle = style({
  opacity: 0.6,
});

export const titleStyle = recipe({
  variants: {
    closeable: {
      true: {
        paddingRight: theme.spacings.l,
      },
    },
  },
});
